import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStore } from '../stores';

@Injectable()
export class TokenInterceptor<T> implements HttpInterceptor {
  private authStore = inject(AuthStore);

  public intercept(
    request: HttpRequest<T>,
    next: HttpHandler,
  ): Observable<HttpEvent<T>> {
    if (!this.authStore.hasSession()) {
      return next.handle(request);
    }
    const session = this.authStore.getSession();

    // Do not add Authorization header for requests to AWS services (uploading file to S3, etc.)
    if (!request.url.includes('amazonaws')) {
      request = request.clone({
        setHeaders: {
          Authorization: `${session.type} ${session.accessToken}`,
        },
      });
    }
    return next.handle(request);
  }
}
